import React, { useContext, useState } from 'react'
import './FoodDisplay.css'
import { StoreContext } from '../../context/StoreContex'
import FoodItem from '../FoodItem/FoodItem'

const FoodDisplay = ({ category }) => {

  const { food_list, products, setProducts } = useContext(StoreContext)
  const { menuItem, setMenuItem } = useState([])

  console.log(products);
  if(products.length===0){
    return <div className='food-display' id='food-display'>
      <h2>Top Dishes Near you</h2>
      <div className='food-display-list'>
        <p>Loading...</p>
      </div>

    </div>
  }

  console.log(category);

  return (
    <div className='food-display' id='food-display'>
      <h2>Top Dishes Near you</h2>
      <div className='food-display-list'>

        {products.menu.map((menuData) => {

          if (category === "All" || menuData.categoryID === products.catg.find((cat) => cat.catgory === category)._id) {
            return (
              <FoodItem
                key={menuData._id}
                id={menuData._id}
                name={menuData.item}
                description={menuData.description}
                price={menuData.price}
                image={menuData.image}
              />
            );
          }
        })
        }



      </div>

    </div>
  )

}

export default FoodDisplay